import { useState } from "react";
import { Info } from "lucide-react";

export function InfoTooltip({ text, side = "top" }) {
  const [show, setShow] = useState(false);
  const posClass = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  }[side] || "bottom-full left-1/2 -translate-x-1/2 mb-2";

  return (
    <div className="relative inline-flex" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <button
        type="button"
        className="text-slate-500 hover:text-blue-400 transition-colors focus:outline-none"
        data-testid="info-tooltip-trigger"
        tabIndex={-1}
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      {show && (
        <div
          className={`absolute z-50 ${posClass} w-64 rounded-lg shadow-xl px-3 py-2.5 text-xs leading-relaxed pointer-events-none`}
          style={{ backgroundColor: "#0F172A", color: "#f1f5f9", border: "1px solid #1e293b" }}
          data-testid="info-tooltip-content"
        >
          <div className="absolute w-2 h-2 rotate-45" style={{ backgroundColor: "#0F172A", [side === "top" ? "bottom" : "top"]: "-4px", left: "50%", transform: "translateX(-50%) rotate(45deg)" }} />
          {text}
        </div>
      )}
    </div>
  );
}
